import React from 'react';
import 'react-toggle/style.css';
import styled from 'styled-components';

import IRhapsodyQueues from 'src/ServerEntities/IRhapsodyQueues';
import ErrorBox from 'src/SharedComponents/ErrorBox';
import LoadingIndicator from 'src/SharedComponents/LoadingIndicator';
import { SessionContext } from 'src/Views/SessionContext';
import { getRhapsodyHeader, getRhapsodyQueues } from '../ramService';
import QueueSizeChart from './QueueSizeChart';
import { RolesContext } from 'src/Roles/RolesContext';
import IRhapsodyServer from 'src/ServerEntities/IRhapsodyServer';
import { ContentContainer } from '../Intersystems/IntersystemsDashboard';
import useCookie from 'src/CustomHooks/useCookie';
import ServerSelector from 'src/SharedComponents/Select/ServerSelector';

const SiteContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: stretch;
    margin-top: 20px;
`;

interface IProps {
    selectedTypes: string[],
    changeRole: boolean,
    setChangeRole: (changeRole: boolean) => void
};

const OuterContainer = styled.div`
    width: 1050px;
    border-radius: 25px;
    border: 5px solid #44A2D6;
    padding: 2px;
    height: 100%;
`;

const InnerContainer = styled.div`
    padding-bottom: 5px;
    padding-left: 5px;
    padding-right: 5px;
    padding-top: 20px;
    width: 100%;
`;

const TitleBar = styled.div`
    width: 1035§px;
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
    background-color: #1577AE;
    padding: 5px;
    padding-left: 10px;
    color: #FFF;
    text-align: center;
    font-size: 1.2em;
    font-weight: bold;
`;

const isQVera = (headerInfo: IRhapsodyServer[], selectedServer: number) => {
    return headerInfo && headerInfo[selectedServer] && headerInfo[selectedServer].serverType === "QIE"
};

export { isQVera };

const RhapsodyQueues = (props: IProps) => {
    const { state, dispatch } = React.useContext(SessionContext);
    const [loading, setLoading] = React.useState(false);
    const [error, setError] = React.useState("");
    const [queues, setQueues] = React.useState(undefined as unknown as IRhapsodyQueues);
    const [data, setData] = React.useState(undefined as unknown as IRhapsodyServer[]);
    const [selectedNamespace, setSelectedNamespace] = useCookie<string>('selectedNamespace', '');
    const selectedServer = state.selectedSever ?? 0;

    const setSelectedServer = (index: number) => {
        dispatch({ type: "setSelectedServer", payload: index });
    };
    const roleContext = React.useContext(RolesContext);
    const currentRole = roleContext.state.role;
    const headerInfo = state.headerInfo ? state.headerInfo : data as IRhapsodyServer[];
        
    React.useEffect(() => {
        if (!state.headerInfo) {
            setLoading(true);
            getRhapsodyHeader(state.webToken, (serverData: IRhapsodyServer[]) => {
                setLoading(false);
                setError("");
                setData(serverData);
                dispatch({ type: "setHeaderInfo", payload: serverData });
            }, (errorMessage: string) => {
                setLoading(false);
                setError(errorMessage);
            });
        }
    }, [state.webToken, currentRole]);

    React.useEffect(() => {
        if (headerInfo && headerInfo[selectedServer]) {
            setLoading(true);
            getRhapsodyQueues(headerInfo[selectedServer].id, isQVera(headerInfo, selectedServer) ? selectedNamespace : null, state.webToken, (data: IRhapsodyQueues) => {
                setLoading(false);
                setQueues(data);
                setError("");
            }, (errorMessage: string) => {
                setLoading(false);
                setError(errorMessage);
            });
        }
    }, [state.webToken, selectedNamespace, selectedServer]);

    return <ContentContainer>
        <LoadingIndicator type="Linear" show={loading} />
        {error && <ErrorBox>{error}</ErrorBox>}
        <SiteContainer>
            <ServerSelector headerInfo={headerInfo} selectedNamespace={selectedNamespace}
                selectedServer={selectedServer} setSelectedNamespace={setSelectedNamespace} setSelectedServer={setSelectedServer}/>
            <OuterContainer>
                <TitleBar>Queue Sizes</TitleBar>
                <InnerContainer>
                    <QueueSizeChart queues={queues} />
                </InnerContainer>
            </OuterContainer>
        </SiteContainer>
    </ContentContainer>;
};

export default RhapsodyQueues;
